import React, { forwardRef } from 'react'
import Svg, { Line, Polyline, SvgProps } from 'react-native-svg'

const PromptIcon = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  ({ fillColor = '#212121', ...props }, ref) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
      ref={ref}
    >
      <Polyline
        points='5 7 10 12 5 17'
        stroke={fillColor}
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Line
        x1={13}
        y1={17}
        x2={19}
        y2={17}
        stroke={fillColor}
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  )
)

export default PromptIcon
